import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CalendarState {
  selectedAgentIds: number[];
  selectedCustomerId: number | null;
}

const initialState: CalendarState = {
  selectedAgentIds: [],
  selectedCustomerId: null,
};

const calendarSlice = createSlice({
  name: "calendar",
  initialState,
  reducers: {
    setSelectedCalendarAgents: (state, action: PayloadAction<number[]>) => {
      state.selectedAgentIds = action.payload;
    },
    setSelectedCustomerId: (
      state,
      action: PayloadAction<number | undefined | null>
    ) => {
      state.selectedCustomerId = action.payload || null;
    },
    resetStore: (state) => {
      state.selectedAgentIds = [];
      state.selectedCustomerId = null;
    },
  },
});

export const { setSelectedCalendarAgents, setSelectedCustomerId, resetStore } =
  calendarSlice.actions;
export const calendarSliceActions = calendarSlice.actions;
export default calendarSlice.reducer;
